import React, { useState } from 'react';
import styles from '../../../styles/hardware-partners/hardwarePartner.module.css';
import { AdvanceAnalyticsBanner, BlackCustomButton, HardwareFeatures, HardwareTab, MarqueeComponentHomePage, Tabs, TransparentCustomButton, WhiteCustomButton } from '@/components/qbStrap';
import Image from 'next/image';
import OutletFeatures from '@/components/common/OutletFeatures';
import { ClientsArr1, testimonialData, tvsFAQ, sunmiPOSMachine, sunmiScanner, sunmiCashDrawer, videoTestimonial, sunmiFAQ , getTitleContent } from '@/constants/common';
import ThreeStepForm from '@/components/common/ThreeStepForm';
import TestimonialSection from '@/components/common/TestimonialSection';
import TrustFactor from '@/components/common/TrustFactor';
import FrequentQuestions from '@/components/homePage/FrequentQuestions';
import PersonalisedDemoBanner from '@/components/common/PersonalisedDemoBanner';
import VerificationPopup from '@/components/modals/VerificationPopup';
import { useRouter } from 'next/router';
import content from '../../../language/ENGLISH.json';

const DesktopSunmi = () => {

    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const router = useRouter();

    const { commonMarqueTitle } = getTitleContent();
    const sunmiData = [
        {
            heading: `POS Machines`,
            content: <HardwareFeatures features={sunmiPOSMachine} setDemoModal={setDemoModal} setHeading={setHeading} />,
        },
        {
            heading: `Cash Drawer`,
            content: <HardwareFeatures features={sunmiCashDrawer} setDemoModal={setDemoModal} setHeading={setHeading} />,
        },
        {
            heading: `Barcode Scanner`,
            content: <HardwareFeatures features={sunmiScanner} setDemoModal={setDemoModal} setHeading={setHeading} />,
        },
    ]

    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                <div className={styles.text_container}>
                    <div className={styles.hardware_logo}><Image src="/assets/Integration/Hardwares/sunmi.webp" alt="TVSE" fill /></div>
                    <h1 className={styles.page_heading}>
                        <span className={styles.small_black_text}>Reimagined Checkout Experience</span><br />
                        <span className={styles.black_text}>With</span><span className={styles.blue_text}> Sunmi POS Terminals</span>
                    </h1>
                    <p className={styles.page_desc}>Own the power of the world-leading POS technology for your retail business with the next-gen QueueBuster and Sunmi machines.</p>

                    <div className={styles.btn_container}>
                        <BlackCustomButton text="Try It Free" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("14 Days free trial"))} />
                        <TransparentCustomButton text="Contact Sales" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("Contact Sales"))} />
                    </div>
                </div>
                <div className={styles.hero_img} style={{ width: "44rem" }}><Image src="/assets/hardware-partners/sunmi/hero-img.webp" alt="tvse" fill /></div>
            </div>

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.portable_devices}>
                <h2>Billing and a Bit More with QueueBuster</h2>
                <Tabs data={sunmiData} style={{ position: "sticky" }} />
            </div>
            <AdvanceAnalyticsBanner heading={'Transform Your Sunmi Hardware Into a Complete POS Solution'} desc={"All your Sunmi device needs is a makeover of a dynamic and flexibly integrated POS software built to last with rapid billing, easy inventory management and extensive real-time reporting."} setDemoModal={setDemoModal} setHeading={setHeading} />
            <div style={{ margin: "0 9.3rem" }}><ThreeStepForm /></div>

            <div style={{ margin: "5rem 6rem" }}><TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /></div>
            <TrustFactor />

            <FrequentQuestions FaqTableData={sunmiFAQ} heading={"FAQs for Sunmi and QueueBuster’s Seamless Compatibility"} />
            <div style={{ margin: "0 9.3rem" }}><PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} /></div>
        </>
    )
}

export default DesktopSunmi